if (document.querySelector('script[src="https://static.panomax.com/front/thumbnail/js/pmaxthumbnail.js"]')) {
    try {
        PmaxThumbnail.place({
            instance: 3032,
            width: '960',
            height: '650',
            showTimestamp: true,
        });
    } catch (e) {
        console.error("Couldn't load webcam: " + e);
    }
}
